import type { Tournament } from '@chess-uno/shared-protocol'
import type { Messages } from './i18n/index.js'

/** Name to show: the one the host chose, or a default built from the host's name. */
export function tournamentName(tournament: Pick<Tournament, 'name' | 'hostName'>, t: Messages): string {
  return tournament.name || t.tournament.defaultName(tournament.hostName)
}

/** Label of a round ("Semi-finals", or "Semi-final" for one match), from its position in the bracket. */
export function roundLabel(round: number, totalRounds: number, t: Messages, one = false): string {
  const fromEnd = totalRounds - round
  return one ? t.tournament.roundOne(fromEnd) : t.tournament.roundName(fromEnd)
}
